"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheTypography = void 0;

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _core = require("../core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Use typography to present your design and content as clearly and efficiently as possible
 */
var RocheTypography = _Typography["default"];
exports.RocheTypography = RocheTypography;
RocheTypography.displayName = (0, _core.rochePrefix)('Typography');
var _default = RocheTypography;
exports["default"] = _default;